import { QUERY } from '@/constants/common';

export const PERSISTED_QUERY_PARAMS = [
  `${QUERY.q}[${QUERY.price}][]`,
  `${QUERY.q}[${QUERY.isShop}]`,
  `${QUERY.q}[${QUERY.regionId}]`,
  'order',
  QUERY.keywordsSource,
  QUERY.userId,
];
